export class SuepModelService {
  static currentModel = '';
}